import { ReactNode } from "react";
import { PageCollectionNavigation, TabType } from "./PageCollectionNavigation";
import { NavigationBarMenu } from "../navigation/NavigationBar";
import { twMerge } from "tailwind-merge";
import { useMediaQuery } from "usehooks-ts";

export const PageCollectionLayout = ({
  title,
  tabsLeft,
  tabsRight,
  topComponent,
  rightComponent,
  children,
  onClickBack,
}: {
  title: string;
  tabsLeft?: TabType[];
  tabsRight?: TabType[];
  topComponent?: ReactNode;
  rightComponent?: ReactNode;
  children: ReactNode;
  onClickBack?: () => void;
}) => {
  const isDesktop = useMediaQuery("(min-width: 1200px)");

  return (
    <>
      <NavigationBarMenu
        title={title}
        leftIcon={"CHEVRON_LEFT"}
        onClickLeftIcon={onClickBack}
        rightComponent={rightComponent}
      />

      <div className={twMerge("mx-auto max-w-[1200px]", isDesktop && "p-2")}>
        {topComponent && <div className="py-4">{topComponent}</div>}
        <PageCollectionNavigation tabsLeft={tabsLeft} tabsRight={tabsRight} />
        {children}
      </div>
    </>
  );
};
